// extracted by mini-css-extract-plugin
module.exports = {"container":"Collection_container__3btP8","name":"Collection_name__2MnRg","image":"Collection_image__1OfEf"};